import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC910mzd8OV-iLnShBi_hIKlqpRHu9Fwcg",
  authDomain: "prasotip-ca4a0.firebaseapp.com",
  projectId: "prasotip-ca4a0",
  storageBucket: "prasotip-ca4a0.firebasestorage.app",
  messagingSenderId: "201733047557",
  appId: "1:201733047557:web:159d6be65ff9d62ed4236c",
  measurementId: "G-6W7WF2FC78",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
export const auth = getAuth(app);

// FCM is not supported on iOS Safari (no PushManager / service worker push).
// Guard before calling getMessaging() to avoid a crash that would blank the whole app.
const messagingSupported =
  typeof window !== "undefined" &&
  "Notification" in window &&
  "serviceWorker" in navigator &&
  "PushManager" in window;
export const messaging = messagingSupported ? getMessaging(app) : null;

export { db, storage };
